import { Injectable } from '@angular/core';

@Injectable()
export class ParameterData {
    DebtorIdParameters: any;
    InvoiceIdParameters: any;
    AccessMenuValues:any;
    constructor() {

    }
}